/**
 * orga-app-api - pandemie-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VeranstaltungPandemieCheckSchwellenwert { 
    pandemie_level_id?: number;
    gueltig_ab_datum?: string;
    wert?: number;
}

